const contactForm = {
  sk: {
    contact_title: "V prípade záujmu nás neváhajte kontaktovať!",
    contact_subtitle: "Radi Vám poradíme (PO - PIA 8:00 - 17:00)",
    contact_form_title: "Alebo vyplňte tento formulár.",
    contact_form_subtitle:
      "Nezáväznú cenovú ponuku Vám zašleme do dvoch hodín.",
    contact_count: "Počet kusov (odporúčame)",
    contact_phone: "Telefónné číslo (odporúčame)",
    contact_name: "Meno / Názov Firmy",
    contact_send: "Odoslať dopyt",
  },
  cs: {
    contact_title: "V případě zájmu nás neváhejte kontaktovat!",
    contact_form_title: "Nebo vyplňte tento formulář.",
    contact_form_subtitle:
      "Nezávaznou cenovou nabídku Vám zašleme do dvou hodin.",
    contact_count: "Počet kusů (doporučujeme)",
    contact_phone: "Telefonní číslo (doporučujeme)",
    contact_name: "Jméno / Název Firmy",
    contact_send: "Odeslat poptávku",
  },
};

export default contactForm;
